import React, {useState} from 'react';
import {APIEmbed} from "discord-api-types/v10";
import Box from "../../Common/Box";
import {Avatar} from "@mui/material";
import utils from "../../lib/utils";
import {Message} from "../../lib/stores/MessageStore";
import {darken, useTheme} from "@mui/material/styles";
import MarkdownRenderer from "./MarkdownRenderer";

function splitMarkdown(markdown: string) {
    const codeBlockRegex = /```[\s\S]*?```/g;
    const result = [];
    let lastIndex = 0;
    let match;

    while ((match = codeBlockRegex.exec(markdown)) !== null) {
        const codeBlock = match[0];
        const beforeCodeBlock = markdown.slice(lastIndex, match.index);
        if (beforeCodeBlock.trim() !== '') {
            result.push(beforeCodeBlock.trim());
        }
        result.push(codeBlock.trim());
        lastIndex = match.index + codeBlock.length;
    }

    const remainingText = markdown.slice(lastIndex);

    if (remainingText.trim() !== '') {
        result.push(remainingText.trim());
    }

    const mergedResult = [];
    let currentText = '';

    result.forEach((item) => {
        if (item.startsWith('```') && item.endsWith('```')) {
            if (currentText !== '') {
                mergedResult.push(currentText.trim());
                currentText = '';
            }
            mergedResult.push(item);
        } else {
            currentText += item + '';
        }
    });

    if (currentText !== '') {
        mergedResult.push(currentText.trim());
    }

    return mergedResult;
}

export const EmbedsMessage = ({message}: { message: Message }) => {


    const {
        embeds,
        author,
        // avatar_url,
        content,
    } = message;

    const theme = useTheme();
    const avatar_url = utils.createAvatarUrl(author['avatar'], 30)
    const [avatarUrl, setAvatarUrl] = useState(avatar_url);

    return <Box
            column
            sx={{
                boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 3px 1px -2px rgba(0, 0, 0, 0.24), 0 1px 5px 0 rgba(0, 0, 0, 0.2)",
                border: "1px solid",
                backgroundColor: darken(theme.palette.background.paper, 0.4),
                borderColor: darken(theme.palette.background.paper, 0.5),
                borderRadius: "4px",
                margin: "15px",
                padding: "10px",
                overflow: "hidden",
                wordBreak: "break-all",
            }}>
        <div style={{
            display: "flex",
            alignItems: "center"
        }}>
            <img
                    crossOrigin="anonymous"
                    style={{
                        minWidth: "30px",
                        minHeight: "30px",
                        width: "30px",
                        height: "30px",
                        borderRadius: "15px",
                        marginRight: "10px",
                        //@todo what is this
                        // "&:after": {
                        //     content: '"\\f1c5" " " attr(alt)',
                        //     fontSize: "0",
                        //     fontFamily: "FontAwesome",
                        //     color: "rgb(100, 100, 100)",
                        //     display: "block",
                        //     position: "absolute",
                        //     zIndex: 2,
                        //     top: "0",
                        //     left: "0",
                        //     width: "100%",
                        //     height: "100%",
                        // }
                    }}
                    src={avatar_url || avatarUrl}
                    alt={''}
                    onError={() => {
                        if (!avatarUrl) {
                            setAvatarUrl(utils.createAvatarUrl())
                        }

                    }}
            />
            <Box fontWeight={500}>
                {/*@todo: this might cause problems if author doesnt exist*/}
                {author?.username}
            </Box>
        </div>

        <Box flex={1} flexDirection={"column"}>

            <Box
                    style={{
                        wordBreak: "break-word"
                    }}
                    paddingTop={"5px"}>
                {embeds.map((embed: APIEmbed, i: number) => {
                    const {
                        author,
                        title,
                        color,
                        image,
                        description,
                        fields = [],
                        footer,
                    } = embed;


                    return <Box key={i}>

                        {author && <Box row sx={{alignItems: "center"}}>
                            {author?.icon_url && <Avatar
                                    alt={"Avatar for " + author.name}
                                    src={author.icon_url}
                                    sx={{width: 32, height: 32, marginRight: "10px"}}
                            />} {author.name}
                        </Box>}

                        {title && <Box>{title}</Box>}

                        {description && <Box>{description}</Box>}

                        {image && <img style={{width: "100%", objectFit: "contain"}}
                                       src={image.url} alt={"embed image"}/>}

                        {fields.map((field, i) => {
                            return <Box key={i}>
                                {field.name && <Box> {field.name}</Box>}
                                {splitMarkdown(field.value).map((subv, i) => {
                                    return <MarkdownRenderer key={i} markdown={subv}/>
                                })}
                            </Box>
                        })}
                        {footer && <Box>{footer.text}</Box>}

                    </Box>
                })}
            </Box>
        </Box>
    </Box>
};
